// extracted by mini-css-extract-plugin
export default {"homeLink":"Application_homeLink__VWqg-","loading":"Application_loading__l5XsM","TDSContainer":"Application_TDSContainer__9PgZr","TDScontent":"Application_TDScontent__VxyOr"};